'use client';

/**
 * Étoile Hall of Fame (anneau épais + point central).
 * Géométrie unique partagée par `hof` et `hof2` pour un rendu identique
 * partout (header, résultats de recherche, carte fidélité, page hall-of-fame).
 * Les paths sont en currentColor : la couleur se pilote via `text-*`.
 */
export default function HofIcon({ className = 'flex-shrink-0 size-4' }) {
  return (
    <svg className={className} viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path fill="currentColor" d="M31.81 11.61H19.66L15.88 0L12.14 11.61H0L9.79 18.79L6.05 30.4L15.88 23.22L25.72 30.41L22 18.79L31.81 11.61ZM12.23 18L6.23 13.66H13.59L15.84 6.66L18.1 13.66H25.48L19.57 18L21.83 25L15.88 20.67L10 25L12.23 18Z" />
      <path fill="currentColor" d="M18.1901 16.9999C18.1901 16.5431 18.0546 16.0965 17.8008 15.7166C17.5469 15.3367 17.1862 15.0406 16.7641 14.8658C16.342 14.6909 15.8775 14.6452 15.4294 14.7343C14.9813 14.8235 14.5697 15.0435 14.2467 15.3665C13.9236 15.6896 13.7036 16.1012 13.6145 16.5493C13.5253 16.9974 13.5711 17.4618 13.7459 17.8839C13.9207 18.306 14.2168 18.6668 14.5967 18.9206C14.9766 19.1745 15.4232 19.3099 15.8801 19.3099C16.4927 19.3099 17.0803 19.0666 17.5135 18.6334C17.9467 18.2002 18.1901 17.6126 18.1901 16.9999Z" />
    </svg>
  );
}
